import { gql, useQuery } from "@apollo/client";
import { Spinner } from "evergreen-ui";
import React from "react";
import { exportToCsv } from "src/utilities";
import styled from "styled-components";
import { VictoryPie, VictoryBar, VictoryChart } from "victory";

const Title = styled.h1`
  ${(props) => props.theme.title}
`;

const GET_DATA = gql`
  {
    rank: analyze_users_current_rank_count_by_day {
      count
      package {
        name
        chinese_name
        package_country {
          id
          name
        }
      }
    }
    joinDate: analyze_users_join_count_by_day {
      count
      day
      month
      year
    }
    restock: analyze_users_restock(order_by: { quantity: desc }) {
      user_id
      name
      username
      quantity
      system_offer
    }
    restockByMonth: analyze_users_restock_by_month {
      user_id
      name
      username
      quantity
      system_offer
      month
      year
    }
  }
`;
const AdminDashboardPresenter = () => {
  const { data, loading, error } = useQuery(GET_DATA);

  const exportUserByRank = () => {
    let csv = "Users by rank\n\nPACKAGE,COUNTRY,USER AMOUNT\n";
    data?.rank?.map((u) => {
      csv =
        csv +
        `${u.package ? u.package.chinese_name : "No rank"},${
          u?.package?.package_country?.name || "No country"
        },${u.count}\n`;
    });
    exportToCsv(csv, "User_by_rank.csv");
  };

  const exportUserJoinDate = () => {
    let csv = "Users by sales\n\nDATE,USER AMOUNT\n";
    data?.joinDate?.map((u) => {
      csv = csv + `${u.day}/${u.month}/${u.year},${u.count}\n`;
    });
    exportToCsv(csv, "User_by_joiningdate.csv");
  };

  const exportUserRestock = () => {
    let csv = "User by sales \n\n NAME,USERNAME,QUANTITY,SYSTEM OFFER,\n";
    data?.restock?.map((stock) => {
      csv =
        csv +
        `${stock.name},${stock.username},${stock.quantity},${stock.system_offer}\n`;
    });
    exportToCsv(csv, "User_by_sales.csv");
  };

  const exportUserRestockByMonth = () => {
    let csv =
      "Users by sales, Grouped by month\n\nMONTH,NAME ,USERNAME,QUANTITY,SYSTEM OFFER\n";
    data?.restockByMonth?.map((stock) => {
      csv =
        csv +
        `${stock.month}/${stock.year},${stock.name},${stock.username},${stock.quantity},${stock.system_offer}\n`;
    });
    exportToCsv(csv, "User_sales_by_month.csv");
  };
  return (
    <div className=" flex flex-col w-full h-auto p-4 ">
      <Title>Dashboard</Title>
      <div className="w-full mx-auto grid grid-cols-1 md:grid-cols-3 row-gap-5 col-gap-5 py-2">
        <div className=" chart-box">
          <div className=" chart-box-header">
            <Title>Users by rank</Title>
            <p onClick={exportUserByRank} className=" link-text">
              Export Data
            </p>
          </div>
          {loading && <Spinner />}
          {error?.message}
          {data?.rank && (
            <VictoryPie
              innerRadius={40}
              colorScale={["tomato", "orange", "gold", "navy", "blue"]}
              data={data?.rank?.map((u) => {
                return {
                  x: u.package
                    ? u.package.chinese_name + ": " + u.count
                    : "没身份: " + u.count,
                  y: u.count,
                };
              })}
            />
          )}
        </div>
        <div className=" chart-box">
          <div className=" chart-box-header">
            <Title>Users join date</Title>
            <p onClick={exportUserJoinDate} className=" link-text">
              Export Data
            </p>
          </div>
          {loading && <Spinner />}
          {error?.message}
          {data?.joinDate && (
            <VictoryChart domainPadding={{ x: 15 }}>
              <VictoryBar
                style={{
                  data: {
                    fill: "#6193F6",
                  },
                }}
                data={[
                  ...data?.joinDate.map((join, index) => {
                    return {
                      x: join.day + "/" + join.month + "/" + join.year,
                      y: join.count,
                    };
                  }),
                ]
                  .slice(0, 5)
                  .reverse()}
              />
            </VictoryChart>
          )}
        </div>
        <div className=" chart-box">
          <div className=" chart-box-header">
            <Title>Users by sales</Title>
            <div className=" flex flex-row items-center">
              <p onClick={exportUserRestock} className=" link-text mr-2">
                Export Data
              </p>
              <p onClick={exportUserRestockByMonth} className=" link-text">
                Export By Month
              </p>
            </div>
          </div>
          {loading && <Spinner />}
          {error?.message}
          {data?.restock && (
            <VictoryChart domainPadding={{ x: 10 }}>
              <VictoryBar
                horizontal
                style={{
                  data: {
                    fill: "#6193F6",
                  },
                }}
                data={data?.restock
                  .map((stock) => {
                    return {
                      y: stock.quantity,
                      x: stock.name,
                    };
                  })
                  .slice(0, 9)
                  .reverse()}
              />
            </VictoryChart>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardPresenter;
